import ClientListWithMap from "./ClientListWithMap"

export default  ClientListWithMap;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/index.js